import { UserOrganizationQuestionnaireForm } from './user'

export interface Questionnaire {
	_id: string
	['form_id']: number
	['questionnaire_id']: string
	created: string
	coachId: string
	patientId: string
	formData?: UserOrganizationQuestionnaireForm
	responseReceived?: string
	responseData?: QuestionnaireResponseData
}

export interface QuestionnaireResponseData {
	id: string
	details: {
		['form_id']: number
	}
	data: {
		[key: string]: string
	}
}

export interface PatientQuestionnaireState {
	questionnaires: Array<Questionnaire>
	filter: PatientQuestionnaireFilters
}

export type QuestionnaireListData = Array<Array<string | Array<Questionnaire>>>

export interface QuestionnaireFormData {
	id: string | number
	title: string
	text: string
	['ui_text']: string
}

export enum PatientQuestionnaireFilters {
	SENT = 'SENT',
	RECEIVED = 'RECEIVED',
}

export enum PATIENT_QUESTIONNAIRE_LOCALES {
	QUESTIONER_1 = 'QUESTIONER_1',
	QUESTIONER_1_BODY = 'QUESTIONER_1_BODY',
	QUESTIONER_2 = 'QUESTIONER_1',
	QUESTIONER_2_BODY = 'QUESTIONER_1_BODY',
	QUESTIONNAIRE_MEASUREMENT_ACCURACY = 'QUESTIONNAIRE_MEASUREMENT_ACCURACY',
	QUESTIONNAIRE_MEASUREMENT_ACCURACY_BODY = 'QUESTIONNAIRE_MEASUREMENT_ACCURACY_BODY',
	QUESTIONNAIRE_QUICK_GOALS = 'QUESTIONNAIRE_QUICK_GOALS',
	QUESTIONNAIRE_QUICK_GOALS_BODY = 'QUESTIONNAIRE_QUICK_GOALS_BODY',
}

export interface SendQuestionnaireMessageRequestData {
	email: string
	title: string
	body: string
	['form_id']: number
}

/**
 * Questionnaire redux store types
 */

export enum PATIENT_QUESTIONNAIRE_ACTION_TYPES {
	PATIENT_QUESTIONNAIRE_SET = 'PATIENT_QUESTIONNAIRE_SET',
	PATIENT_QUESTIONNAIRE_SET_FILTER = 'PATIENT_QUESTIONNAIRE_SET_FILTER',
}

export interface PatientQuestionnaireSetAction {
	type: PATIENT_QUESTIONNAIRE_ACTION_TYPES.PATIENT_QUESTIONNAIRE_SET
	payload: Array<Questionnaire>
}

export interface PatientQuestionnaireSetFilter {
	type: PATIENT_QUESTIONNAIRE_ACTION_TYPES.PATIENT_QUESTIONNAIRE_SET_FILTER
	payload: PatientQuestionnaireFilters
}

export type PatientQuestionnaireActions =
	| PatientQuestionnaireSetAction
	| PatientQuestionnaireSetFilter
